import styled from '@emotion/styled';
import { AlertCircle } from 'react-feather';
import { Spinner } from '@trinity/chat-components/components/presentation/Spinner.js';
import { Tooltip } from '@trinity/chat-components/components/presentation/Tooltip.js';
import { FileTranscriptStatus, type WorkspaceFileTranscript } from '@/types';

type Props = {
  className?: string;
  transcript: WorkspaceFileTranscript | null;
};

export function TranscriptStatus({ className, transcript }: Props) {
  if (!transcript) {
    return null;
  }

  if (transcript.status === FileTranscriptStatus.InProgress) {
    return (
      <Tooltip title="Transcript is being processed">
        <div className={className}>
          <Spinner />
        </div>
      </Tooltip>
    );
  }

  if (transcript.status === FileTranscriptStatus.Errored) {
    return (
      <Tooltip title="Error during transcription">
        <StyledAlertCircle className={className} />
      </Tooltip>
    );
  }

  return null;
}

const StyledAlertCircle = styled(AlertCircle)({
  color: 'var(--pri-04)',
});
